import React from "react";
import DataTable from "../DataTable/DataTable";

const CashlessData = ({ loading, filteredData, pagination, onTableChange }) => {
  const columns = [
    {
      title: "SI NO",
      key: "si_no", 
 
      render: (text, record, index) => {

        const pageIndex = pagination?.current || 1;
        const pageSize = pagination?.pageSize || 10;
        return (pageIndex - 1) * pageSize + index + 1;
      },
    },
    {
      title: "HOSPITAL NAME",
      dataIndex: "hospital_name",
      key: "hospital_name",
    },
    {
      title: "ADDRESS",
      dataIndex: "hospital_address",
      key: "hospital_address",
    },
    {
      title: "LOCATION",
      dataIndex: "location",
      key: "location",
    },
    {
      title: "LANDMARK",
      dataIndex: "landmark",
      key: "landmark",
    },
    {
      title: "CITY",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "STATE",
      dataIndex: "state",
      key: "state",
    },
    {
      title: "PINCODE",
      dataIndex: "pincode",
      key: "pincode",
    },
    {
      title: "EMAIL",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "PHONE NUMBER",
      dataIndex: "phone",
      key: "phone",
    },
  ];

  return (
    <DataTable
      columns={columns}
      pagination={pagination}
      loading={loading}
      dataSource={filteredData}
      rowKey={(record, index) => record.id || index}
      onChange={onTableChange}
    />
  );
};

export default CashlessData;